"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = PieChart;
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var React = require("react");
var d3 = require("d3");
require("./style.scss");
var d3Hoc = function (renderFn, dependencies) {
    var ref = React.useRef();
    React.useEffect(function () {
        renderFn(d3.select(ref.current));
        return function () {
            /** */
        };
    }, dependencies);
    return ref;
};
function PieChart(props) {
    var ref = d3Hoc(function (div) {
        var margin = { left: 20, right: 20, top: 20, bottom: 20 };
        var outerWidth = props.width;
        var outerHeight = props.height;
        var width = outerWidth - margin.left - margin.right;
        var height = outerHeight - margin.top - margin.bottom;
        var r = Math.min(width, height) / 2;
        var arc = d3
            .arc()
            .outerRadius(r)
            .innerRadius(r - 15);
        var arcHover = d3
            .arc()
            .outerRadius(r + 3)
            .innerRadius(r - 15);
        div.selectAll('svg').remove();
        var svg = div
            .append('svg')
            .style('width', "".concat(outerWidth, "px"))
            .style('height', "".concat(outerHeight, "px"));
        var tooltip = div
            .append('div')
            .attr('class', 'sok-tooltip-box')
            .style('position', 'absolute')
            .style('visibility', 'hidden')
            .style('opacity', 0);
        var pie = d3.pie().value(function (d) { return d.value; });
        // svg.append('g').attr('transform', `translate(50, 50)`)
        svg
            .append('g')
            .selectAll('path')
            .data(pie(props.data))
            .enter()
            .append('path')
            .attr('class', 'arc')
            .attr('transform', "translate(".concat(outerWidth / 2, ",").concat(outerHeight / 2 - margin.top / 2, ")"))
            .attr('d', arc)
            .on('mouseover', function (event, d) {
            d3.select(this).transition().duration(500).attr('d', arcHover);
            tooltip
                .style('left', event.pageX + 'px')
                .style('top', event.pageY + 'px')
                .style('visibility', 'visible')
                .style('opacity', 1)
                .text(d.value);
        })
            .on('mouseout', function (e) {
            d3.select(this).transition().duration(500).attr('d', arc);
            tooltip.style('visibility', 'hidden').style('opacity', 0);
        });
        svg.selectAll('path').style('fill', function (d, i) { return d.data.color; });
    }, props.data);
    if (props.status === 'FETCHED') {
        return (React.createElement("div", { className: 'svg-container' },
            React.createElement("div", { ref: ref, style: {
                    height: props.height,
                    width: props.width
                } }),
            React.createElement("div", { className: 'legend-container', style: { width: '100%' } }, props.data.map(function (legend, idx) {
                return (React.createElement("div", { key: "legend-".concat(idx), className: 'legend-item' },
                    React.createElement("div", { className: 'legend-box', style: { background: legend.color } }),
                    React.createElement("div", { className: 'legend-label' }, legend.label)));
            }))));
    }
    else {
        return (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: "no-entries", key: "no-entries", title: "diaryEntriesView/emptyList/title", message: "diaryEntriesView/emptyList/message" }));
    }
}
